import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PublicProfile } from './pages/PublicProfile';
import { Dashboard } from './pages/Dashboard';
import { DashboardHome } from './pages/DashboardHome';
import { DashboardEditProfile } from './pages/DashboardEditProfile';
import { DashboardInsights } from './pages/DashboardInsights';
import { DashboardShare } from './pages/DashboardShare';
import { Homepage } from './pages/Homepage';
import { Login } from './pages/Login';
import { AdminUsers } from './pages/AdminUsers';
import { Onboarding } from './pages/Onboarding';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Homepage data-id="element-3" />} data-id="element-2" />
        <Route path="/login" element={<Login data-id="element-5" />} data-id="element-4" />
        <Route path="/onboarding" element={<Onboarding data-id="element-7" />} data-id="element-6" />
        <Route path="/marcuschen" element={<PublicProfile data-id="element-9" />} data-id="element-8" />
        <Route path="/admin" element={<Dashboard data-id="element-11" />} data-id="element-10">
          <Route index element={<DashboardHome data-id="element-13" />} data-id="element-12" />
          <Route path="edit" element={<DashboardEditProfile data-id="element-15" />} data-id="element-14" />
          <Route path="insights" element={<DashboardInsights data-id="element-17" />} data-id="element-16" />
          <Route path="share" element={<DashboardShare data-id="element-19" />} data-id="element-18" />
          <Route path="users" element={<AdminUsers data-id="element-21" />} data-id="element-20" />
        </Route>
      </Routes>
    </BrowserRouter>;
}